<template>
    <div class="content-wrapper">
        <div class="container-lg">
            <div class="row mb-12">
                <div class="col">
                    <div class="page-title-nav row">
                        <div class="col-2 col-lg-3">
                            <router-link :to="`/member/home`" class="btn btn-outline-secondary btn-custom btn-back">
                                <i class="fa-icon fa-regular fa-arrow-left me-0"></i><span
                                    class="d-none d-lg-block ms-2">ย้อนกลับ</span>
                            </router-link>
                        </div>
                        <div class="col-8 col-lg-6">
                            <h1 class="page-title">โพยหวย</h1>
                        </div>
                        <div class="col-12 col-lg-3">
                            <a href="#" class="btn btn-primary btn-custom d-none"><i
                                    class="fa-icon fa-regular fa-home"></i><span></span></a>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6 col-lg-4 d-grid">
                            <app-balanceDay :balanceDay="numberWithCommas(
                                list.filter(e => (e.isToday && (Number(e.status) != 2)))
                                    .map(e => e.price)
                                    .reduce((a, b) => Number(a) + Number(b), 0))
                                " />
                        </div>
                        <div class="col-6 col-lg-4 d-grid">
                            <app-listDay :qtyListDay="list.filter(x => (x.isToday)).map(e => e.status).length" />
                        </div>
                        <div class="col-12 col-lg-4 d-grid">
                            <app-listCancel
                                :qtyCancel="list.filter(x => ((Number(x.status) == 2) && x.isToday)).map(e => e.status).length" />
                        </div>
                        <div class="col-6 d-grid">
                            <app-listSuccess
                                :qtySuccess="list.filter(x => ((Number(x.status) !== 0) && x.isToday)).map(e => e.status).length" />
                        </div>
                        <div class="col-6 d-grid">
                            <app-listInprocess
                                :qtyInprocess="list.filter(x => ((Number(x.status) == 0) && x.isToday)).map(e => e.status).length" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="content-card">
                                <div class="content-card-title d-flex justify-content-start flex-wrap gap-2">
                                    <button v-for="(filter, index) in filters" :key="index"
                                        :class="['btn', 'btn-filter', filter.active ? 'btn-outline-primary btn-active bg-primary text-white' : 'btn-outline-secondary']"
                                        @click="setActiveFilter(index)">
                                        <i class="fa-icon fa-solid"
                                            :class="[filter.active ? 'fa-circle-check' : 'fa-circle']"></i>{{
                                                filter.name }}
                                    </button>
                                </div>
                                <div class="content-card-body ">
                                    <div class="row" v-if="activeFilter === 'ทั้งหมด'">
                                        <template v-for="(item, index) in display_list">
                                            <div :key="item.id" class="col-lg-3 col-12 col-md-4">
                                                <div class=" p-0 table-active poy-content active"
                                                    v-if="display_list.length > 0">
                                                    <div class="card border-primary mb-3 ">
                                                        <div class="card-header p-0 card-header-border" style="">
                                                            <div class="poy-list-head">
                                                                <small>โพย เลขที่{{ index }}</small>
                                                                <span>#{{ item.TicketId }}</span>&nbsp;
                                                                <div class="poy-status notyet"
                                                                    v-if="item.status == 0 || item.status == 1">
                                                                    {{ item.statusName }}
                                                                </div>
                                                                <div class="poy-status"
                                                                    :class="item.status == 2 ? 'lost' : 'success'"
                                                                    v-else-if="item.status == 2">
                                                                    {{ item.statusName }}
                                                                </div>
                                                                <div class="poy-status"
                                                                    :class="item.IsWinPrice ? 'success' : 'lost'"
                                                                    v-else>
                                                                    {{ item.IsWinPrice ? 'ถูกรางวัล' : 'ไม่ถูกรางวัล' }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="card-body card-body-border text-primary p-0">
                                                            <div class="row">
                                                                <div class="col">
                                                                    <div class="poy-list-content">
                                                                        <div class="row">
                                                                            <div class="col-7 m-0 pl-2 pr-1">
                                                                                <div class="poy-type">
                                                                                    <span class="font-weight-bold ">{{
                                                                                        item.title
                                                                                    }}</span><br />
                                                                                    <br />
                                                                                    <small>วันที่ : {{
                                                                                        getDate(item.dateBetting)
                                                                                        }}</small>
                                                                                </div>
                                                                            </div>
                                                                            <div
                                                                                class="col m-0 pl-1 pr-3 pb-1 border-left">
                                                                                <div
                                                                                    class="d-flex justify-content-between">
                                                                                </div>
                                                                                <div
                                                                                    class="d-flex justify-content-between">
                                                                                    <small>เงินเดิมพัน</small>
                                                                                    <span class=""><span
                                                                                            class="thb text-primary">฿
                                                                                            {{
                                                                                                numberWithCommas(item.price)
                                                                                            }}</span></span>
                                                                                </div>
                                                                                <div
                                                                                    class="d-flex justify-content-between">
                                                                                    <small>ผลแพ้/ชนะ</small>
                                                                                    <span class=""><span class="thb">฿
                                                                                            {{
                                                                                                numberWithCommas(item.WinAmount)
                                                                                            }}</span></span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="card-footer p-0 card-footer-border" style="">

                                                            <div class="d-flex justify-content-between">
                                                                <div class="row">
                                                                    <div class="col">
                                                                        <span class="badge text-dark"><i
                                                                                class="fa-icon fa-regular fa-calendar"></i>
                                                                            {{
                                                                                getDate(item.dateBetting) }}</span>
                                                                        <span class="badge text-dark mr-5"><i
                                                                                class="fa-icon fa-regular fa-clock"></i>
                                                                            {{ getTime(item.dateBetting) }}</span>
                                                                    </div>
                                                                </div>
                                                                <div class="row" style="padding-right: 10px;">
                                                                    <div class="col p-2 ">
                                                                        <router-link
                                                                            :to="`/member/lotto/result/${item.TicketId}`"
                                                                            class="btn btn-secondary btn-sm py-0 px-1 float-right">รายละเอียด
                                                                            <i class="fas fa-search"></i></router-link>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                    <div v-else class="row">
                                        <template v-for="(item, index) in display_list">
                                            <!-- {{ item }} -->
                                            <div :key="item.id" v-if="activeFilter === item.statusName"
                                                class="col-lg-3 col-12 col-md-4">
                                                <div class=" p-0 table-active poy-content active"
                                                    v-if="display_list.length > 0 && activeFilter === item.statusName">
                                                    <div class="card border-primary mb-3 ">
                                                        <div class="card-header p-0 card-header-border" style="">
                                                            <div class="poy-list-head">
                                                                <small>โพย เลขที่{{ index }}</small>
                                                                <span>#{{ item.TicketId }}</span>&nbsp;
                                                                <div class="poy-status notyet"
                                                                    v-if="item.status == 0 || item.status == 1">
                                                                    {{ item.statusName }}
                                                                </div>
                                                                <div class="poy-status"
                                                                    :class="item.status == 2 ? 'lost' : 'success'"
                                                                    v-else-if="item.status == 2">
                                                                    {{ item.statusName }}
                                                                </div>
                                                                <div class="poy-status"
                                                                    :class="item.IsWinPrice ? 'success' : 'lost'"
                                                                    v-else>
                                                                    {{ item.IsWinPrice ? 'ถูกรางวัล' : 'ไม่ถูกรางวัล' }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="card-body card-body-border text-primary p-0">
                                                            <div class="row">
                                                                <div class="col">
                                                                    <div class="poy-list-content">
                                                                        <div class="row">
                                                                            <div class="col-7 m-0 pl-2 pr-1">
                                                                                <div class="poy-type">
                                                                                    <span class="font-weight-bold ">{{
                                                                                        item.title
                                                                                    }}</span><br />
                                                                                    <br />
                                                                                    <small>วันที่ : {{
                                                                                        getDate(item.dateBetting)
                                                                                        }}</small>
                                                                                </div>
                                                                            </div>
                                                                            <div
                                                                                class="col m-0 pl-1 pr-3 pb-1 border-left">
                                                                                <div
                                                                                    class="d-flex justify-content-between">
                                                                                </div>
                                                                                <div
                                                                                    class="d-flex justify-content-between">
                                                                                    <small>เงินเดิมพัน</small>
                                                                                    <span class=""><span
                                                                                            class="thb text-primary">฿
                                                                                            {{
                                                                                                numberWithCommas(item.price)
                                                                                            }}</span></span>
                                                                                </div>
                                                                                <div
                                                                                    class="d-flex justify-content-between">
                                                                                    <small>ผลแพ้/ชนะ</small>
                                                                                    <span class=""><span class="thb">฿
                                                                                            {{
                                                                                                numberWithCommas(item.WinAmount)
                                                                                            }}</span></span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="card-footer p-0 card-footer-border" style="">

                                                            <div class="d-flex justify-content-between">
                                                                <div class="row">
                                                                    <div class="col">
                                                                        <span class="badge text-dark"><i
                                                                                class="fa-icon fa-regular fa-calendar"></i>
                                                                            {{
                                                                                getDate(item.dateBetting) }}</span>
                                                                        <span class="badge text-dark mr-5"><i
                                                                                class="fa-icon fa-regular fa-clock"></i>
                                                                            {{ getTime(item.dateBetting) }}</span>
                                                                    </div>
                                                                </div>
                                                                <div class="row" style="padding-right: 10px;">
                                                                    <div class="col p-2 ">
                                                                        <router-link
                                                                            :to="`/member/lotto/result/${item.TicketId}`"
                                                                            class="btn btn-secondary btn-sm py-0 px-1 float-right">รายละเอียด
                                                                            <i class="fas fa-search"></i></router-link>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <!-- <b-pagination align="center" v-model="currentPage"
                                                :total-rows="display_list.length" :per-page="perPage"
                                                aria-controls="my-table">
                                            </b-pagination> -->
                                        </div>

                                    </div>
                                    <!-- <div class="row">
                                        <div :key="item.id" class="col-12 col-md-4 col-lg-4" v-for="(item, indexX) in display_list">
                                            <div  class="card border-primary mb-3 " >
                                                <div class="card-header">
                                                    <small>โพย เลขที่{{ indexX }}</small>
                                                    <span>#{{ item.TicketId }}</span>
                                                </div>
                                                <div class="card-body text-primary">
                                                    <h5 class="card-title">Primary card title</h5>
                                                    <p class="card-text">Some quick example text to build on the card
                                                        title
                                                        and make up the bulk of the card's content.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="push"></div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
import { mapActions } from 'vuex'
import { listAllBetHistoryService } from '@/services'
import balanceDay from '@/components/sakha/lotto/reccordList/balanceDay'
import listDay from '@/components/sakha/lotto/reccordList/listDay'
import listCancel from '@/components/sakha/lotto/reccordList/listCancel'
import listSuccess from '@/components/sakha/lotto/reccordList/listSuccess'
import listInprocess from '@/components/sakha/lotto/reccordList/listInprocess'
// import listTable from '@/components/sakha/lotto/reccordList/listTable'

export default {
  components: {
    'app-balanceDay': balanceDay,
    'app-listDay': listDay,
    'app-listCancel': listCancel,
    'app-listSuccess': listSuccess,
    'app-listInprocess': listInprocess
    // 'app-listTable': listTable
  },
  async created () {
    this.setLoading(true)
    const resp = await listAllBetHistoryService()
    if (resp.status_code === 'SUCCESS') {
      const data = resp.data.map(e => {
        return {
          ...e,
          numberbet: [],
          // numberbet: e.numberbet,
          WinAmount: parseInt(e.WinAmount),
          IsWinPrice: JSON.parse(e.IsWinPrice),
          isToday: JSON.parse(e.isToday),
          dateBetting: moment(e.dateBetting)
        }
      })
      console.log('created-------------------')
      this.list = data.filter(v => (Number(v.group_id) !== Number(3) && Number(v.group_id) !== Number(4)))
      this.reloadDataList()
      // -1, 0, 3, 2
      this.setLoading(false)
    }
  },
  methods: {
    ...mapActions(['setLoading']),
    getDate (date) {
      return moment(date).format('DD-MM-YYYY')
    },
    getTime (date) {
      return moment(date).format('HH:mm:ss')
    },
    getTapPoyActive (data) {
      return (Number(this.selectedPoy) === Number(data))
    },
    getCanDisplay (group_id, status, index, isToday) {
      console.log('getCanDisplay-----------')
      console.log(group_id, status, index, isToday, this.selectedPoy)
      let result = true
      /* check status ticket */

      if ((Number(this.activeFilterId) === Number(status))) {
        result &= true
      }
      return result
    },
    numberWithCommas (x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    reloadDataList () {
      this.currentPage = 1
      console.log(this.list)
      this.display_list = this.list.filter((item, indexItem) => this.getCanDisplay(item.group_id, item.status, indexItem, item.isToday))
      console.log(this.display_list)
    },
    setActiveFilter (index) {
      this.filters.forEach((filter, i) => {
        filter.active = filter.id === this.filters[index].id
      })
      this.activeFilter = this.filters[index].statusName
      this.activeFilterId = this.filters[index].id
      this.reloadDataList()
    }
  },
  data () {
    return {
      activeFilter: 'ทั้งหมด',
      activeFilterId: 0,
      perPage: 300,
      currentPage: 1,
      list: [],
      data_list: [],
      display_list: [],
      selectedHuay: 0,
      selectedPoy: -1,
      options: [
        { gIndex: -1, text: 'หวยทั้งหมด' },
        { gIndex: 0, text: 'หวยไทย' },
        { gIndex: 1, text: 'ยี่กี' },
        { gIndex: 2, text: 'หวยหุ้น' }
      ],
      filters: [
        { id: 0, statusName: 'ทั้งหมด', name: 'ทั้งหมด', active: true },
        { id: 1, statusName: 'รอออกผล', name: 'รอออกผล', active: false },
        { id: 2, statusName: 'ออกผลแล้ว', name: 'ออกผลแล้ว', active: false },
        // { id: 3, statusName: 'จ่ายเงินแล้ว', name: 'จ่ายเงินแล้ว', active: false },
        { id: 3, statusName: 'ยกเลิกโพย', name: 'ยกเลิกโพย', active: false }
        // { id: 5, statusName: '', name: 'setinter', active: false },
        // { id: 6, statusName: '', name: 'ky', active: false }
      ]
    }
  },
  watch: {
    selectedHuay: function (val) {
      this.reloadDataList()
    },
    selectedPoy: function (val) {
      this.reloadDataList()
    }
  },
  computed: {
    activeTable () {
      return this.tables[this.activeFilter]
    }
  }
}
</script>
<style lang="less">
.content-wrapper {
    font-family: "IBM Plex Sans Thai", sans-serif !important;
}

.btn-block {
    display: block !important;
    width: 100% !important;
}

.poy-list-content {
    background: white;
    padding: 5px 10px;
    color: #6c757d;
}

.poy-list-content .row .col .ribbon-lotto i {
    font-size: 14px !important;
}

.poy-list-content .row .col .ribbon-lotto {
    background: rgba(0, 0, 0, 0.3);
    height: 20px;
    width: auto;
    display: inline-block;
    position: absolute;
    color: #fff;
    line-height: 20px;
    padding: 0px 5px;
    margin-top: 5px;
    border-left: rgba(0, 0, 0, 0.3) 1px solid;
    font-size: 16px;
}

.poy-list-content .row .col .ribbon-lotto:after {
    content: "";
    position: absolute;
    display: block;
    bottom: 0;
    border: 10px solid rgba(0, 0, 0, 0.3);
    right: -10px;
    height: 20px;
    border-left-width: 0px;
    border-right-color: transparent;
    filter: drop-shadow(6px 6px 3px rgba(0, 0, 0, 0.04));
}

.card-header-border {
    border-style: solid !important;
    border-color: #75a0e1 !important;
    border-top-width: 2px;
    border-right-width: 2px;
    border-left-width: 2px;
}

.card-body-border {
    border-style: solid !important;
    border-color: #75a0e1 !important;
    border-width: 0px 2px 2px 2px;
    // border-top-width: 0px;
    // border-right-width: 2px;
    // border-left-width: 2px;
    // border-bottom-width: 2px;

}

.card-footer-border {
    border-style: solid !important;
    border-color: #75a0e1 !important;
    border-width: 0px 2px 2px 2px;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
}

.poy-list-head {
    width: 100%;
    min-height: 30px;
    line-height: 1;
    border-bottom: #75a0e1 2px solid;
    padding: 6px 10px 0px 10px;
    vertical-align: middle;
    background: #fff;
    overflow: hidden;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;

}

.poy-government small,
.poy-thaistock small,
.poy-foreignstock small,
.poy-yeekee small {
    font-weight: normal !important;
}

.poy-type {
    font-weight: normal;
    font-size: 0.85rem;
    padding: 5px;
    border-radius: 3px;
    line-height: 1.2;
    text-align: right;
    background: #eee;
    color: #000;
}

.poy-type h3 {
    line-height: 1;
    margin-bottom: 0;
}

.number-win {
    color: cadetblue;
    font-size: 170%;
    line-height: 1;
}

.poy-government {
    background: #17a2b8;
}

.poy-thaistock {
    background: var(--color-1-main);
}

.poy-foreignstock {
    background: #6610f2;
}

.poy-yeekee {
    background: #dc3545;
}

.poy-list-head .poy-status {
    display: block;
    float: right;
    margin-top: -6px;
    margin-right: -10px;
    width: auto;
    min-height: 30px;
    /* box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    border: 4px solid rgba(255, 255, 255, 0.5); */
    color: #000;
    font-size: 80%;
    /* padding-top: 12px; */
    padding-top: 8px;
    overflow: hidden;
    padding-left: 5px;
    padding-right: 5px;
}

.poy-list-head .poy-status.notyet {
    background: #ffc107;
}

.poy-list-head .poy-status.success {
    background: #3ac028;
    color: white;
}

.poy-list-head .poy-status.win {
    background: #3ac028;
    color: white;
}

.poy-list-head .poy-status.lost {
    background: #dc3545;
    color: white;
}
</style>
